import React from "react";

/**
 * A horizontal progress bar showing feature usage against quota.
 *
 * @param {{ label: string, used: number|null, limit: number|null, window: string, windowEnd: string|null }} props
 */
export default function UsageMeter({ label, used, limit, window, windowEnd }) {
  const isUnlimited = limit === null || limit === undefined;
  const consumed = limit != null && used != null ? limit - used : null;
  const percentage = limit != null && limit > 0 && consumed != null
    ? Math.min(100, Math.round((consumed / limit) * 100))
    : 0;

  const getBarColor = () => {
    if (isUnlimited) return "bg-primary/60";
    if (percentage >= 90) return "bg-destructive";
    if (percentage >= 70) return "bg-yellow-500";
    return "bg-success";
  };

  const formatWindow = (w) => {
    const labels = { day: "Daily", week: "Weekly", month: "Monthly", rolling: "Rolling", lifetime: "Lifetime" };
    return labels[w] || w;
  };

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-textPrimary font-medium">{label}</span>
        <span className="text-textSecondary text-xs">
          {isUnlimited ? (
            "Unlimited"
          ) : (
            <>
              <span className="font-medium text-textPrimary">{consumed ?? 0}</span>
              {" / "}
              <span>{limit}</span>
              <span className="ml-1.5 text-textSecondary/70">({formatWindow(window)})</span>
            </>
          )}
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-2 w-full rounded-full bg-secondary/30 overflow-hidden">
        {isUnlimited ? (
          <div className="h-full w-full bg-primary/30 rounded-full" />
        ) : (
          <div
            className={`h-full rounded-full transition-all duration-500 ${getBarColor()}`}
            style={{ width: `${percentage}%` }}
          />
        )}
      </div>

      {/* Window end info */}
      {windowEnd && (
        <p className="text-xs text-textSecondary/70">
          Resets{" "}
          {new Date(windowEnd).toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </p>
      )}
    </div>
  );
}
